import { PaymentElement } from '@liquidweb-dev/undercurrent/stripe';
import Stack, { type StackProps } from '@liquidweb-dev/undercurrent/Stack';
import combineSx from '@liquidweb-dev/undercurrent/utility/combineSx';

import { HookedCheckbox } from 'components/Form';
import HookedSubmit from 'components/Form/HookedSubmit';

export interface ChoosePaymentMethodStripeProps
	extends Omit<StackProps, 'children'> {
	/** true while the payment is being begun and the entered card authorized */
	isSubmitting: boolean;
	/** true once Stripe is loaded and able to take a card */
	readyToSubmit: boolean;
}

/** Collects a new card through Stripe */
const ChoosePaymentMethodStripe = ({
	isSubmitting,
	readyToSubmit,
	sx,
	...rest
}: ChoosePaymentMethodStripeProps) => (
	<Stack sx={combineSx({ gap: 200 }, sx)} {...rest}>
		<Stack sx={{ gap: 150 }}>
			<PaymentElement
				options={{
					// with layout tabs, if there is only one payment method
					// available, no tabs render - which is what we want
					layout: 'tabs',
					// The backend refuses every method whose Stripe type is not a
					// plain card, so never offer one we cannot save.
					wallets: {
						applePay: 'never',
						googlePay: 'never',
						link: 'never',
					},
				}}
			/>
			<HookedCheckbox name="savePaymentMethod" label="Save for later" />
		</Stack>

		<HookedSubmit
			disabled={!readyToSubmit}
			loading={isSubmitting}
			size="large"
			color="highlight"
		>
			Continue
		</HookedSubmit>
	</Stack>
);

export default ChoosePaymentMethodStripe;
